import script from "./ViberActivation.vue?vue&type=script&setup=true&lang=js"
export * from "./ViberActivation.vue?vue&type=script&setup=true&lang=js"

import "./ViberActivation.vue?vue&type=style&index=0&id=78d48e5f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78d48e5f"]])

export default __exports__